export default __webpack_public_path__ + "static/media/klutcher.d98a887c.png";